import { render, staticRenderFns } from "./prj-header.vue?vue&type=template&id=0e1b51fa"
import script from "./prj-header.vue?vue&type=script&lang=js"
export * from "./prj-header.vue?vue&type=script&lang=js"
import style0 from "./prj-header.vue?vue&type=style&index=0&id=0e1b51fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports